import React from 'react';
import { Clock, ShieldCheck } from 'lucide-react';

interface WorkspacePlaceholderProps {
  title: string;
  description?: string;
}

const WorkspacePlaceholder: React.FC<WorkspacePlaceholderProps> = ({ title, description }) => (
  <section className="workspace-placeholder" aria-labelledby="placeholder-title">
    <div className="placeholder-icon">
      <Clock size={22} />
    </div>
    <p className="overline">Workspace module</p>
    <h1 id="placeholder-title">{title}</h1>
    <p>
      {description || 'This approved CyberShield module is reserved for the next workflow slice.'}
    </p>
    <div className="placeholder-note">
      <ShieldCheck size={15} />
      <span>No mock actions are exposed here. Functionality will be connected only when the matching workflow is implemented.</span>
    </div>
  </section>
);

export default WorkspacePlaceholder;
